import { createElement, FC, useContext } from 'react';
import { RouteComponentProps } from 'react-router';

import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import Page from '../page/ShowAdAnalyticsReportPage';

type Props = RouteComponentProps;

const AdAnalyticsReportPage: FC<Props> = () => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);

  return (
    <Page
      loading={state.adAnalyticsVideos.fetching >= 1}
      language={state.language}
      analyticsVideos={state.adAnalyticsVideos.items}
      dailyPerformance={state.adAnalyticsVideos.dailyPerformances}
      analyticsReport={state.adAnalyticsReport.item}
      submitComment={state.adAnalyticsReport.submitComment}
      placementTypes={state.adAnalyticsPlacementTypes.placementTypes}
      checkSubmitComment={() => {
        dependency.showAdAnalyticsReportUsecase.checkSubmitComment();
      }}
      tryUpdateReport={({ comment }: { comment: string }) => {
        dependency.showAdAnalyticsReportUsecase.tryUpdateReport({ comment });
      }}
      onGotoAnalyticsReportListPage={() => {
        dependency.showAdAnalyticsReportUsecase.goAnalyticsReportListPage();
      }}
      onMount={() => {
        dependency.authenticationUsecase.needSignedIn();
        dependency.showAdAnalyticsReportUsecase.prepare();
      }}
      onUnmount={() => {
        dependency.showAdAnalyticsReportUsecase.dispose();
      }}
    />
  );
};

export default AdAnalyticsReportPage;
